import { render, staticRenderFns } from "./importDeclareML.vue?vue&type=template&id=21c6b11f&scoped=true"
import script from "./importDeclareML.vue?vue&type=script&lang=js"
export * from "./importDeclareML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c6b11f",
  null
  
)

export default component.exports